import React, { useState, useEffect } from "react";

export default function Home() {
  const [useadvertisement, setadvertisement] = useState(null);
  console.warn("10000", useadvertisement);
  const [time, setTime] = useState(null);

  useEffect(() => {
    markets();
  }, []);

  const markets = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/Admin/public/api/markets`,
        {
          method: "POST",
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const data = await response.json();
      console.warn(data); // Log the response data
      setadvertisement(data); // Update state with the response data
      // settime(response);
      const livetime = data.livetime; // Accessing livetime from the response data
      setTime(livetime);
    } catch (error) {
      console.error("Error:", error);
    }
  };


  const [adsData, setAdsData] = useState([]);
  const formatTime = (time) => {
    if (!time) return "";

    const [hour, minute] = time.split(":");
    let h = parseInt(hour);
    const ampm = h >= 12 ? "PM" : "AM";

    h = h % 12 || 12;

    return `${h}:${minute} ${ampm}`;
  };
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/Admin/public/api/market-result-time`)
      .then((res) => res.json())
      .then((result) => {
        const markets = result?.data || [];

        const timesArray = markets.map((item) => {
          return `⏰ ${item.market_name} ----------- ${formatTime(
            item.market_sunday_time_open
          )}`;
        });

        // 3 static users same रख सकते हो
        const dynamicAds = [
          {
            // name: "ARJUN BHAI KHAIWAL",
            name: "a7-sattakingg.com",
            number: data?.whatsapp_link,
            times: timesArray,
          },

        ];

        setAdsData(dynamicAds);
      })
      .catch((error) => {
        console.log("API Error:", error);
      });
  }, []);

  ////////////////// genral-setting////////////////////////



  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/Admin/public/api/genral-setting`)
      .then((res) => res.json())
      .then((result) => {
        setData(result.data); // ✅ yahi fix tha
      })
      .catch((error) => {
        console.log("API Error:", error);
      });
  }, []);

  return (
    <div>
      <section className="circlebox">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="liveresult">
                <div className="datetime">
                  <div id="clockbox">{time}</div>
                  <p className="hintext newschange">
                    हा भाई यही आती हे सबसे पहले खबर रूको और देखो
                  </p>
                </div>
                {/* <div style={{ width: '100%' }}>
                <div className="sattaname">
                  <p>JAY SHRI SHYAM</p>
                </div>
                <div className="sattaresult">
                  <font>
                    <span>54</span>
                  </font>
                </div>
                <div className="sattaname">
                  <p>Shri Ganesh</p>
                </div>
                <div className="sattaresult">
                  <font>
                    <span>Wait</span>
                  </font>
                </div>
                <div className="sattaname">
                  <p>Yamunanagar City</p>
                </div>
                <div className="sattaresult">
                  <font>
                    <span>
                      <strong>
                      <h1 className="text-red blink-soft">Wait</h1>  
                      </strong>
                    </span>
                  </font>
                </div>
              </div> */}

                {useadvertisement &&
                  useadvertisement.data &&
                  useadvertisement.data.livetodayResult &&
                  useadvertisement.data.livetodayResult.length > 0 && (
                    <React.Fragment>
                      {useadvertisement.data.livetodayResult.map(
                        (market, index) => (
                          <div
                            className="col-md-12 p-0 col-sm-12 col-xs-12 color-withe aslogo"
                            key={index}
                          >
                            <div style={{ color: "white" }}>
                              <p className="livegame">{market.market_name}</p>
                              <p className="liveresult">
                                {/* {market.result <= 9 || market.result === "" ? "Wait" : market.result} */}
                                {/* {market.result <= 9 || market.result === "" ? (
                                  <div class="sattaresult"><font><span><strong><h1 class="text-red blink-soft">Wait</h1></strong></span></font></div>
                                ) : (
                                  market.result
                                )} */}
                                {market.result === "" ||
                                  /^\d$/.test(market.result) ? (
                                  <div className="sattaresult">
                                    <font>
                                      <span>
                                        <strong>
                                          <h1 className="text-red blink-soft">
                                            Wait
                                          </h1>
                                        </strong>
                                      </span>
                                    </font>
                                  </div>
                                ) : (
                                  market.result
                                )}
                              </p>
                            </div>
                          </div>
                        ),
                      )}
                    </React.Fragment>
                  )}
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="bg-light pb-2">
        <div className="telegram-card">
          <div className="row">
            <div className="notification">
              <p>
                Now Telegram players can also join our Telegram channel to get
                results quickly and receive superfast results.
              </p>

              <a
                href={data?.telegram_link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://i.ibb.co/DgD35m7F/telegram-logo-to-connect-channel.png"
                  alt="telegram"
                />
              </a>
            </div>
          </div>
        </div>

        <div className="telegram-card">
          <div className="row">
            <div className="notification">
              <p>
                Now WhatsApp players can also join our WhatsApp channel to get
                results quickly and receive superfast results.
              </p>

              <a
                href={`https://wa.me/${data?.whatsapp_link}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src="https://i.ibb.co/4RJCLbSB/whatsapp.png"
                  alt="WhatsApp"
                />
              </a>
            </div>
          </div>
        </div>

        {/* <div className="telegram-card">
          <div className="row">
            <div className="notification">
              <p>
                <a
                  href="https://a7satta.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Shri Ganesh Satta King
                </a>
                result is updated everyday at <strong>4:40 PM</strong>.
              </p>
            </div>
          </div>
        </div>

        <div className="telegram-card">
          <div className="row">
            <div className=" notification">
              <p>
                <a
                  href="https://a7-sattakingg.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sadar Bazar Satta King 2025
                </a>
                Chart is available on A7Sattakingg.com
              </p>
            </div>
          </div>
        </div> */}

        <section className="ads-container">
          {adsData.map((ad, index) => (
            <div className="column-ad" key={index}>
              <div className="ad-card">
                <p>--सीधे सट्टा कंपनी का No 1 खाईवाल--</p>

                <p>♕♕ {ad.name} ♕♕</p>

                {ad.times.map((time, i) => (
                  <p key={i}>{time}</p>
                ))}

                <p>🙂🙂 {ad.name} 🙂🙂</p>

                <a href={`https://wa.me/${ad.number}`}>
                  Game play करने के लिये नीचे लिंक पर क्लिक करे
                </a>
                <a href={`https://wa.me/${data?.whatsapp_link}`} className="d-block">
                  <img
                    className="whatsapp-icon"
                    src="https://i.ibb.co/4RJCLbSB/whatsapp.png"
                    alt="whatsapp"
                  />
                </a>

                <br />


              </div>
            </div>
          ))}

        </section>
      </div>
    </div>
  );
}
